<template>
  <div v-if="user" class="ac-mention pa-2">
    <UserAvatar :user="user" color="grey600" :size="24" class="mr-2" />
    <span class="font-weight-bold" v-text="user.name" />
    <span class="text--secondary" v-text="`#${user.shortId}`" />
    <v-spacer />
    <span class="grey200--text" v-text="$t('layout.chat.ac.user')" />
  </div>
  <div v-else class="ac-mention pa-2" :style="{color}">
    <fai :icon="['far', 'at']" fixed-width class="text-body-1 mr-1" />
    <span class="text-truncate" v-text="value" />
    <v-spacer />
    <span class="grey200--text" v-text="$t('layout.chat.ac.emote')" />
  </div>
</template>

<script>
import { PING_EVERYONE, PING_MODS } from '@/utils/constants/chat'

export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    meta: {
      type: Object,
      default: null,
    },
  },
  computed: {
    user() {
      return this.meta
    },
    color() {
      const { dark: theme } = this.$vuetify.theme.themes

      if (this.value === PING_EVERYONE) return theme.warning
      if (this.value === PING_MODS) return theme.success

      return null
    },
  },
}
</script>

<style lang="scss" scoped>
.ac-mention {
  display: flex;
  align-items: center;
}
</style>
